<div>
  <div class="search-holder mb-15">
    <input placeholder="Search for short codes ..." type="search" class="form-control" [formControl]="searchControl" />
    <span class="icon-search"></span>
  </div>
  <div>
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <table class="table table-condensed data-table">
      <thead>
        <tr>
          <th>
            <div *ngIf="multiple && limit === 0" class="checkbox checkbox-primary">
              <input [ngModel]="batchSelected" (click)="onClickBatchSelect()" type="checkbox" />
              <label></label>
            </div>
            <div *ngIf="multiple && limit > 0">Limit {{ limit - selectCount }}</div>
          </th>
          <th>Phone Number</th>
          <th>Country</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!rows.length">
          <td [colSpan]="4" class="text-center">No results</td>
        </tr>
        <tr *ngFor="let row of getRows()" (click)="onClickRow(row)">
          <td>
            <input type="checkbox" class="form-check-input" type="checkbox" [ngModel]="row.selected"
              [disabled]="limit > 0 && !row.selected && selectCount >= limit" />
          </td>
          <td>{{row.phoneNumber}}</td>
          <td>{{row.country}}</td>
          <td>{{row.description}}</td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
      <div class="pagination-left">
        <app-pagination *ngIf="totalCountRows > size" [pageSize]="size" [totalItems]="totalCountRows" [buttonsCount]="pageCountButtons" [currentPage]="page"
          (change)="onChangePage($event)"></app-pagination>
      </div>

      <div class="d-flex align-items-center justify-content-end pagination-right">
        <ul *ngIf="sizes.length" class="pagination">
          <li *ngFor="let s of sizes" [ngClass]="{'active': s === size}">
            <a (click)="onChangeSize(s)">{{ s }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
